module.exports = __webpack_public_path__ + "static/media/trofeus (5).3f1ec225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Trofeus/trofeus (5).jpg
// module id = 369
// module chunks = 0